"use client";

import GcsImage from "@/components/common/GcsImage";
import { underline } from "@/lib/gcsImagePaths";

export default function ReferralBanner() {
  return (
    <section className="bg-[#209FBD] text-white min-h-[60px] py-2 flex items-center">
      <div className="container mx-auto px-4 text-center w-full">
        <p className="text-lg md:text-xl font-semibold">
          A friend thought you deserved{" "}
          <span className="relative inline-block">
            better
            <GcsImage
              path={underline}
              alt="Decorative underline"
              className="absolute top-full left-0 w-full h-auto -mt-2 scale-y-[0.68]"
            />
          </span>{" "}
          insurance at a{" "}
          <span className="relative inline-block">
            better
            <GcsImage
              path={underline}
              alt="Decorative underline"
              className="absolute top-full left-0 w-full h-auto -mt-2 scale-y-[0.68]"
            />
          </span>{" "}
          price. We agree!
        </p>
      </div>
    </section>
  );
}
